import React from 'react';
import { toArray } from 'react-emoji-render';

export function parseEmojis(value: string) {
  const emojisArray = toArray(value);

  // toArray outputs React elements for emojis and strings for other
  const newValue = emojisArray.reduce((previous, current) => {
    if (typeof current === 'string') {
      return previous + current;
    }
    return previous + (current as React.ReactElement)?.props?.children;
  }, '');

  return newValue as string;
}
